import * as React from "react";
import Svg, { SvgProps, G, Path, Defs, ClipPath } from "react-native-svg";

const WebErrorIcon = (props: SvgProps) => (
  <Svg width={80} height={60} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        fill="#979C9E"
        d="M19.688 39.017a4.673 4.673 0 0 0-3.315 1.373 4.687 4.687 0 0 0 3.314 8.002h29.688v-9.375H19.687ZM73.75 1.517H6.25a4.688 4.688 0 0 0-4.688 4.687v7.813h76.876V6.204a4.688 4.688 0 0 0-4.688-4.687ZM10.312 8.548a1.562 1.562 0 1 1 0-3.125 1.562 1.562 0 0 1 0 3.125Zm6.25 0a1.562 1.562 0 1 1 0-3.125 1.562 1.562 0 0 1 0 3.125Zm6.25 0a1.562 1.562 0 1 1 0-3.125 1.562 1.562 0 0 1 0 3.125Z"
      />
      <Path
        stroke="#979C9E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={3.516}
        d="M73.75 57.767H6.25a4.687 4.687 0 0 1-4.688-4.688V6.204A4.687 4.687 0 0 1 6.25 1.517h67.5a4.687 4.687 0 0 1 4.688 4.687V53.08a4.687 4.687 0 0 1-4.688 4.688Z"
      />
      <Path
        stroke="#979C9E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={3.516}
        d="M60.313 48.392H19.687a4.687 4.687 0 1 1 0-9.375h40.626a4.687 4.687 0 1 1 0 9.375ZM35.313 20.267l9.374 9.375M44.688 20.267l-9.376 9.375"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h80v59.375H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default WebErrorIcon;
